<template>
  <Loading v-if="loading" />
  <div class="general">
    <FormKit
      id="general-form"
      v-model="formData"
      type="form"
      :actions="false"
      @submit="submitHandler"
    >
      <div
        v-for="(option, index) in generalOptions"
        :key="index"
        class="general__options"
      >
        <TitleOptions :title="$t(option.label)" />
        <div
          v-if="option.value === 'screenTimeout'"
          class="options__input-screenTimeout"
        >
          <Input
            type="number"
            name="screen_timeout"
            :value="formData.screen_timeout"
            required
          />
        </div>
        <div v-if="option.value === 'color'" class="options__input-color">
          <p class="color">
            {{ formData.color }}
          </p>
          <FormKit v-model="formData.color" type="color" name="color" />
          <span v-if="!formData.color" class="chooseColor">
            {{ $t('chooseColor') }}
          </span>
        </div>
        <PhotoTab
          v-if="option.value === 'photo'"
          :existing-photo="formData.logo"
          @update:image-src="imageSrc = $event"
        />
      </div>
    </FormKit>
    <Button
      class="general-button"
      variant="filled"
      :title="$t('save')"
      @click="submitForm"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import { generalOptions } from './configs';
import { Color, OptionsScreen } from '@/store/modules/pharmacy/types';

@Options({
  name: 'General',
  components: {
    Loading
  },

  data() {
    return {
      loading: false,
      generalOptions,
      formData: {
        screen_timeout: 10,
        logo: '',
        color: ''
      }
    };
  },
  computed: {
    ...mapState('pharmacy', ['pharmacy'])
  },
  created() {
    this.show();
  },
  methods: {
    ...mapActions('pharmacy', ['getPharmacy', 'updateFeedbackTemplate']),
    async show() {
      this.loading = true;

      const { id } = this.$route.params;
      await this.getPharmacy(id);

      this.formData = {
        ...this.pharmacy.feedbackTemplate,
        color: `#${this.pharmacy.feedbackTemplate.color}`
      };

      this.loading = false;
    },
    changeColor(color: Color) {
      this.formData.color = color.hex;
    },
    updateLogo(imageSrc: string) {
      this.formData.logo = imageSrc;
    },
    async submitHandler(data: OptionsScreen) {
      this.loading = true;

      const payload = {
        ...data,
        screen_timeout: +this.formData.screen_timeout,
        logo: this.imageSrc || this.formData.logo,
        color: data.color.slice(1)
      };

      const { id } = this.$route.params;
      await this.updateFeedbackTemplate({ data: payload, pharmacyId: id });

      this.loading = false;

      this.$router.go(0);
    },
    async submitForm() {
      const logo = this.formData.logo;

      if (typeof logo === 'string') {
        const payload = {
          color: this.formData.color.slice(1),
          screen_timeout: +this.formData.screen_timeout
        };

        const { id } = this.$route.params;
        await this.updateFeedbackTemplate({ data: payload, pharmacyId: id });
        this.$router.go(0);
      } else {
        this.$formkit.submit('general-form');
      }
    }
  },
  watch: {
    pharmacy() {
      if (this.pharmacy) {
        this.formData = {
          ...this.pharmacy.feedbackTemplate,
          color: `#${this.pharmacy.feedbackTemplate.color}`
        };
      }
    }
  }
})
export default class General extends Vue {}
</script>

<style lang="scss">
.general {
  padding: 0 24px 24px 24px;
  #general-form {
    margin-bottom: 30px;
    .general__options {
      .options__input-screenTimeout {
        input {
          height: 48px;
          width: 100px;
          margin-bottom: 0;
          .formkit-input {
            height: 30px;
          }
        }
      }
      .options__input-color {
        position: relative;
        display: flex;
        align-items: center;
        .color {
          display: inline-block;
          width: 250px;
          height: 30px;
          font-size: 14px;
          border-radius: 8px;
          border: 1px solid $border;
          padding-left: 15px;
          padding-top: 16px;
        }
        .formkit-outer[data-type='color'] {
          width: 23px;
          height: 27px;
          margin: 0 24px;
          .formkit-wrapper {
            width: 23px;
            height: 27px;
            .formkit-inner {
              width: 23px;
              height: 27px;
              .formkit-input {
                width: 23px;
                height: 27px;
                padding: 0;
                border-radius: 0;
                border: none;
              }
            }
          }
        }
        .chooseColor {
          font-size: $fourteenSize;
          color: $red;
        }
        button {
          margin-left: 24px;
        }
      }
    }
  }
}
</style>
